import {Box, Skeleton} from '@viptech/react-components'
import createStyleSheet from 'src/utilities/createStyleSheet'

export function PhotoEmphasisSkeleton() {
  return (
    <Box display='flex' direction='column' flex={1} border='2px solid #D0D5DD' backgroundColor='#F2F4F7' padding='8px 16px' rowGap='4px'>
      <Box display='flex' width='100%' direction='column'>
        <Box display='flex' width='100%' justifyContent='space-between'>
          <Box width='89px' display='flex' direction='column'>
            <Skeleton height='16px' />
            <Skeleton width='100%' height='89px' />
          </Box>
          <Box width='89px' display='flex' direction='column'>
            <Skeleton height='16px' />
            <Skeleton width='100%' height='89px' />
          </Box>
        </Box>
      </Box>

      <Box display='flex' direction='column' rowGap='2px'>
        <Skeleton height='8px' />

        <Box display='flex' justify='space-between'>
          <Skeleton width='48px' height='10px' borderRadius='8px' />
          <Skeleton width='32px' height='10px' borderRadius='8px' />
        </Box>
      </Box>
    </Box>
  )
}

export function PhotoEmphasisSkeletonMap({display}: {display: 'flex' | 'none'}) {
  return (
    <Box width='232px' minWidth='232px' display={display} rowGap='16px' direction='column' overflow='auto' style={styles.overflow}>
      {new Array(4).fill(null).map((_, index) => (
        <PhotoEmphasisSkeleton key={index} />
      ))}
    </Box>
  )
}

const styles = createStyleSheet({
  overflow: {
    overflow: 'auto',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
  },
})
